import React from 'react';

import PropTypes from 'prop-types';
import useProvideScopes from 'hooks/useProvideScopes';

import { ScopesContext } from 'context/ScopesContext';

export function ScopesProvider({ children }) {
  const value = useProvideScopes();
  return <ScopesContext.Provider value={value}>{children}</ScopesContext.Provider>;
}

ScopesProvider.propTypes = {
  children: PropTypes.node,
};
